import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import Home from "../Home/Home";
import AboutUs from "../AboutUs/AboutUs";
import Services from "../Services/Services";
import Gallery from "../Gallery/Gallery";
import ContactUs from "../ContactUs/ContactUs";
import Products from "../OurProducts/OurProducts";
import Projects from "../Projects/Projects";
import LocationPage from "../LocationPage/LocationPage";
import ServiceAreas from "../ServiceAreas/ServiceAreas";
import FloatingContactButtons from "../FloatingContactButtons/FloatingContactButtons";

/* BrowserRouter doesn't reset scroll on navigation — do it on every path change */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function Main() {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <ScrollToTop />
      <Header />
      <main style={{ flex: 1, marginTop:'0px' }}>
        <Routes>
          <Route path="/"         element={<Home />} />
          <Route path="/about"    element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/gallery"  element={<Gallery />} />
          <Route path="/contact"  element={<ContactUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/service-areas" element={<ServiceAreas />} />

          {/* ── City SEO landing pages: /landscape-design-noida, …-delhi, etc. ── */}
          <Route path="/:slug" element={<LocationPage />} />
        </Routes>
      </main>

      <Footer />
      <FloatingContactButtons />
    </div>
  );
}
